

export default {
  what3WordsWindow: {
    backgroundColor: "#FFF",
    padding: "7px 15px",
    borderRadius: "5px",
    marginBottom: "10px",
  },
  what3WordsLabel: {
    fontFamily: "AvenirNext-DemiBold",
    fontSize: "12px",
    color: "#96979a",
  },
  what3WordsContent: {
    paddingLeft: "7px",
    fontSize: "12px",
    width:"100px"
  },
};
